import React, { useState, useEffect, useRef } from 'react';
import { ComposableMap, Geographies, Geography, Marker, Line } from 'react-simple-maps';
import { usePublicVendors } from '../services/usePublicVendors';

const GEO_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

function VendorMap() {
  const { vendors: allVendors } = usePublicVendors();
  const vendors = allVendors.filter(v => v.location && v.location.lat && v.location.lng);
  const [tooltip, setTooltip] = useState(null);
  const [arcs, setArcs] = useState([]);
  const cycleRef = useRef(null);

  useEffect(() => {
    if (vendors.length < 2) return;
    const coords = vendors.map(v => [parseFloat(v.location.lng), parseFloat(v.location.lat)]);

    function pickPair() {
      const i = Math.floor(Math.random() * coords.length);
      let j = Math.floor(Math.random() * coords.length);
      while (j === i) j = Math.floor(Math.random() * coords.length);
      const i2 = Math.floor(Math.random() * coords.length);
      let j2 = Math.floor(Math.random() * coords.length);
      while (j2 === i2) j2 = Math.floor(Math.random() * coords.length);
      setArcs(prev => [...prev.slice(-2), { from: coords[i], to: coords[j], key: Date.now() }, { from: coords[i2], to: coords[j2], key: Date.now() + 1 }]);
    }

    pickPair();
    cycleRef.current = setInterval(pickPair, 1000);
    return () => clearInterval(cycleRef.current);
  }, [vendors.length]);

  if (vendors.length < 2) return null;

  const coords = vendors.map(v => [parseFloat(v.location.lng), parseFloat(v.location.lat)]);

  return (
    <div className="vendor-map-section">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 140, center: [0, 30] }}
        className="vendor-map"
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#2a2218"
                stroke="#3a3020"
                strokeWidth={0.5}
                style={{ default: { outline: 'none' }, hover: { outline: 'none' }, pressed: { outline: 'none' } }}
              />
            ))
          }
        </Geographies>
        {arcs.map(a => (
          <Line
            key={a.key}
            from={a.from}
            to={a.to}
            stroke="rgba(74, 255, 180, 0.7)"
            strokeWidth={1.5}
            strokeLinecap="round"
            className="map-arc"
          />
        ))}
        {vendors.map((v, idx) => (
          <Marker
            key={idx}
            coordinates={coords[idx]}
            onMouseEnter={() => setTooltip(v)}
            onMouseLeave={() => setTooltip(null)}
          >
            <circle r={5} className="map-pin" />
          </Marker>
        ))}
      </ComposableMap>
      {tooltip && (
        <div className="map-tooltip">
          <strong>{tooltip.businessName}</strong>
          <span>{tooltip.location.city}{tooltip.location.state ? `, ${tooltip.location.state}` : ''}</span>
        </div>
      )}
    </div>
  );
}

export default VendorMap;
